import { Button } from "@chakra-ui/react";
import React from "react";

import { ApiUploadtasksListRequest } from "@nens/brostar/openapi-client";

import { SearchBox } from "@/components/searchbox";
import { useInvalidateUploadTaskQueries } from "@/queries/query-upload-task";

import { FilterWrapper } from "../../../components/filter-wrapper";
import { uploadTaskInformation } from "../types";
type Props = {
  isLoadingOrRefetching: boolean;
  searchField: keyof ApiUploadtasksListRequest;
  setSearchField: (searchField: keyof ApiUploadtasksListRequest) => void;
  searchString: string;
  setSearchString: (searchString: string) => void;
};

const UploadTaskFilters: React.FC<Props> = ({
  isLoadingOrRefetching,
  searchField,
  setSearchField,
  searchString,
  setSearchString,
}) => {
  const invalidateUploadTaskList = useInvalidateUploadTaskQueries();

  return (
    <FilterWrapper>
      <SearchBox
        searchField={searchField}
        setSearchField={setSearchField}
        searchString={searchString}
        setSearchString={setSearchString}
        searchOptions={uploadTaskInformation}
      />
      <Button
        onClick={invalidateUploadTaskList}
        variant="outlinePrimary"
        isLoading={isLoadingOrRefetching}
        ml="auto"
      >
        Herlaad de upload taken
      </Button>
    </FilterWrapper>
  );
};

export { UploadTaskFilters };
